var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.banner)?_c('div',[_c('div',{staticClass:"takeover-banner",class:'adn-' + _vm.banner.contentText.split('_')[1],staticStyle:{"display":"none"}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }